import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AxiosError } from "axios";

import { INotice } from "../../../interfaces";

import NoticeService from "../../../services/http/services/NoticeService";
import { EmitSuccessAlert } from "../../../utils/EmitSuccessAlert";
import { EmitError } from "../../../utils/EmitError";

export default function useEditNotice() {
    const { id } = useParams();
    const [notice, setNotice] = useState<INotice>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    const navigate = useNavigate();

    useEffect(() => {
        const controller = new AbortController();

        async function loadNotice() {
            try {
                setIsLoading(true);
                const noticeData = await NoticeService.getNoticeById(Number(id), controller.signal);

                setNotice(noticeData);
                setIsLoading(false);
            } catch (err) {
                if (err instanceof AxiosError && err.name === 'CanceledError') {
                    return;
                }

                setIsLoading(false);

                EmitError(err, true, 'editNotice_opasdasjpdasd');

                navigate(`/avisos`);
            }
        }

        loadNotice();

        return () => {
            controller.abort();
        }
    }, [id, navigate]);

    async function handleSubmit(noticeData: INotice) {
        try {
            await NoticeService.updateNotice(Number(id), noticeData);
            EmitSuccessAlert('Aviso atualizado com sucesso!');

            navigate(`/avisos`);
        } catch (err) {
            EmitError(err, true, 'editNotice_asiopdasodasd');
        }
    }

    return {
        isLoading,
        notice,
        handleSubmit
    }
}